import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetOrderQuestionsDocumentsPage } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutDocumentsAndInvoices: FC<
  ContactPageSelfServiceShortcutProps
> = ({ availability }) => {
  const config = useGlobalConfigContext()

  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()

  const subOrder = activeSubOrder ?? firstSubOrder

  if (!subOrder?.subOrderId || !lastOrder?.orderMasterData?.orderNumber) {
    return null
  }

  if (availability === 'disabled') {
    return (
      <Button color="secondary" disabled size="small">
        <FormattedMessage id="contact.self.service.document.soon.available" />
      </Button>
    )
  }

  return (
    <Button<'a'>
      color="secondary"
      href={urlResolverGetOrderQuestionsDocumentsPage(
        config,
        lastOrder.orderMasterData.orderNumber,
        subOrder.subOrderId,
      )}
      size="small"
      slots={{ root: 'a' }}
    >
      <FormattedMessage id="account.orders.details.collapsible.label.documents" />
    </Button>
  )
}
